import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { REGISTRATION_STEP } from 'constants/registrationStep';
import { CrawlerRegistrationInputModalView } from './CrawlerRegistrationInputModalView';
import { CrawlerRegistrationConfirmModalView } from './CrawlerRegistrationConfirmModalView';
import { CrawlerRegistrationResultModalView } from './CrawlerRegistrationResultModalView';
import { useRegistrationStore } from '../../hooks';

type Props = ReturnType<typeof useRegistrationStore>;

export const CrawlerRegistrationModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
  apiKeyTemplates,
  selectedApiKeyTemplate,
  isCheckUnnecessaryApiKey,
  setIsCheckUnnecessaryApiKey,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <CrawlerRegistrationInputModalView
        {...form}
        handleConfirm={onConfirm}
        apiKeyTemplates={apiKeyTemplates}
        isCheckUnnecessaryApiKey={isCheckUnnecessaryApiKey}
        setIsCheckUnnecessaryApiKey={setIsCheckUnnecessaryApiKey}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <CrawlerRegistrationConfirmModalView
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
        selectedApiKeyTemplate={selectedApiKeyTemplate}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <CrawlerRegistrationResultModalView
        values={values}
        handleClose={onCloseModalWhenCompleted}
        selectedApiKeyTemplate={selectedApiKeyTemplate}
      />
    )}
  </Modal>
);
